/**
 * Fallback acknowledgment points for the opt-out dialog when preference has not loaded yet.
 * Canonical source is Aardvark.Shared.Constants.CheckInOptOutConstants (returned by the API).
 */
export const checkInOptOutAcknowledgmentPoints: readonly string[] = [
  'You will continue regular check-in / 1:1 conversations with your team outside Aardvark (or by another agreed process).',
  'Aardvark will not schedule, remind, or store ongoing check-in outcomes for your direct reports while this is turned off.',
  'If check-in history is later needed, you are responsible for producing it from your own records.',
];

/** Shown to employees when their manager has opted out of built-in check-ins. */
export const employeeManagerOptedOutMessage =
  'Your manager has turned off built-in check-ins in Aardvark and confirmed they manage ongoing 1:1 conversations off-system. You will not see a scheduled check-in here.';

export const employeeManagerOptedOutShortLabel =
  'Managed off-system by your manager';

/** My Tasks / Team Roster — ask managers to confirm catch-up cadence, with opt-out escape hatch. */
export const checkInFrequencyConfirmCopy = {
  tasksTitle: (count: number) =>
    `Confirm check-in frequency (${count})`,
  tasksBody:
    'Confirm how often you plan to catch up with each team member (Weekly, Fortnightly, or Monthly) on Team Roster so Aardvark can schedule and remind at that cadence. If you manage 1:1s outside Aardvark, turn off built-in check-ins there instead so you are not emailed about scheduling.',
  tasksAction: 'Confirm frequency',
  rosterWhenBuiltInOn:
    'Confirm how often you plan to catch up with each team member (Weekly, Fortnightly, or Monthly). Aardvark then schedules and reminds at that cadence. If you already run 1:1s outside Aardvark, turn off built-in check-ins below so you are not emailed about scheduling.',
  rosterBuiltInCardWhenOn:
    'Aardvark schedules and tracks check-ins for your direct reports at the cadence you set. Turn this off if you manage 1:1s outside the system — you will not get check-in scheduling or reminder emails while it is off.',
} as const;
